import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {CommonsService} from "@core/service/commons.service";
import {BrowseService} from "@shared/components/browse/browse.service";
import {BizSelectService} from "@shared/components/biz-select/biz-select.service";
import {
  AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors,
  ValidatorFn
} from "@angular/forms";

const TYPE_ARRAY = 'array';
const TYPE_STRING = 'string';
const MODE_DEFAULT = 'default';
const MODE_CLOSEABLE = 'closeable'


export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BizSelectComponent),
  multi: true
};

export const validateCounterRange: ValidatorFn = (control: AbstractControl):
  ValidationErrors => {
  return (!control.value && control.get('required')) ?
    { required:true } : null;
};

export const EXE_COUNTER_VALIDATOR = {
  provide: NG_VALIDATORS,
  useValue: validateCounterRange,
  multi: true
};


/**
 * 业务对象选择
 */
@Component({
  selector: 'biz-select',
  templateUrl: './biz-select.component.html',
  providers:[EXE_COUNTER_VALUE_ACCESSOR, EXE_COUNTER_VALIDATOR]
})
export class BizSelectComponent implements OnInit, ControlValueAccessor {


  @Input() bizObject: string;
  @Input() dataType: string = TYPE_ARRAY;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() multiple: boolean = false;
  @Input() name;
  public fieldData: any;

  mode: string = MODE_CLOSEABLE;

  innerData = [];

  constructor(
    private bizSelectService: BizSelectService,
    private commonsService: CommonsService,
    private browseService: BrowseService
  ) {
  }

  ngOnInit() {
    this.init();
  }

  init() {
    if (this.disabled) {
      this.mode = MODE_DEFAULT;
    } else {
      this.mode = MODE_CLOSEABLE;
    }
    if (this.multiple) {
      if (this.dataType == TYPE_ARRAY) {
        if (!this.fieldData) {
          this.fieldData = [];
        }
        this.innerData = [...this.fieldData];
      } else if (this.dataType == TYPE_STRING) {
        if (this.fieldData) {
          this.innerData = this.fieldData.split(',');
        }
      }
    }
  }


  onClose() {
    this.fieldData = "";
    this.updateData();
  }

  onRemove(item) {
    this.innerData.splice(this.innerData.indexOf(item), 1);
    this.updateData();
  }

  updateData() {
    if (this.multiple) {
      if (TYPE_ARRAY == this.dataType) {
        this.fieldData = [...this.innerData];
      } else if (TYPE_STRING == this.dataType) {
        this.fieldData = this.innerData.join(',');
      }
    }
    this.propagateChange(this.fieldData);
  }

  openBrowse() {
    let bizObjectConfig = this.bizSelectService.getBizObject(this.bizObject);
    this.browseService.open({component: bizObjectConfig.component, multiple: this.multiple,isEdit:true}, (data) => {
      if (this.multiple) {
        data.forEach(item => {
          if (this.innerData.indexOf(item[bizObjectConfig.dataKey]) < 0) {
            this.innerData.push(item[bizObjectConfig.dataKey]);
          }
        });
      } else {
        this.fieldData = data[bizObjectConfig.dataKey];
      }
      this.updateData();
    },
      ()=>{}
    );
  }

  propagateChange = (_: any) => {
  };

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.init();
  }

  writeValue(obj: any): void {
    this.fieldData = obj;
    this.init();
  }
}
